export class ForceMask {
  public readonly mask: Uint8Array;
  public readonly values: Uint8Array;

  constructor(public readonly sizeBytes: number) {
    this.mask = new Uint8Array(sizeBytes);
    this.values = new Uint8Array(sizeBytes);
  }

  isForced(byteOffset: number, bitOffset: number): boolean {
    return ((this.mask[byteOffset] ?? 0) & (1 << bitOffset)) !== 0;
  }

  setForce(byteOffset: number, bitOffset: number, value: boolean): void {
    this.mask[byteOffset] = (this.mask[byteOffset] ?? 0) | (1 << bitOffset);
    if (value) {
      this.values[byteOffset] = (this.values[byteOffset] ?? 0) | (1 << bitOffset);
    } else {
      this.values[byteOffset] = (this.values[byteOffset] ?? 0) & ~(1 << bitOffset);
    }
  }

  clearForce(byteOffset: number, bitOffset: number): void {
    this.mask[byteOffset] = (this.mask[byteOffset] ?? 0) & ~(1 << bitOffset);
  }

  clearAll(): void {
    this.mask.fill(0);
    this.values.fill(0);
  }

  /**
   * Applies the forced values onto a given memory buffer.
   */
  applyTo(buffer: Uint8Array): void {
    const len = Math.min(this.sizeBytes, buffer.length);
    for (let i = 0; i < len; i += 1) {
      const m = this.mask[i] ?? 0;
      if (m !== 0) {
        buffer[i] = ((buffer[i] ?? 0) & ~m) | ((this.values[i] ?? 0) & m);
      }
    }
  }
}
